import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { MarginTopProps } from 'styled-system';
import { marginTop, space } from 'styled-system';

import { Link } from 'common/components/Link';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { SpaceProps } from 'common/theme/system-types';
import type { ListStyleProps } from 'common/theme/system-utilities';
import { listStyle } from 'common/theme/system-utilities';
import { trackMyAccountTooltipClick } from '../../tracking';

const List = styled.ul<SpaceProps & ListStyleProps>`
  ${space}
  ${listStyle}
  ${marginTop}
`;

const listStyles: ComponentProps<typeof List> = {
  m: 'sp_0',
  p: 'sp_0',
  listStyle: 'none',
  mt: 'sp_8',
};

const ListItem = styled.li<MarginTopProps>`
  &:not(:first-of-type) {
    ${marginTop}
  }
`;

const mainBlockItems = [
  {
    text: 'h24_my_overview',
    url: 'h24_my_overview_url',
  },
  {
    text: 'h24_my_orders',
    url: 'h24_my_orders_url',
  },
  {
    text: 'h24_help_contact',
    url: 'h24_help_contact_url',
  },
];

const MainBlock = () => {
  const { t, p } = useLocalization();

  return (
    <List {...listStyles}>
      {mainBlockItems.map(item => (
        <ListItem key={item.text} mt={['sp_16', null, 'sp_8']}>
          <Link href={p.t(item.url)} onClick={() => trackMyAccountTooltipClick(t(item.text))}>
            {t(item.text)}
          </Link>
        </ListItem>
      ))}
    </List>
  );
};

export default MainBlock;
